













import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator'
import copyToClipboard from '@/app/utils/clipboard'

@Component
export default class ClipboardDisplay extends Vue {
  @Prop({ type: String })
  private text!: String | null

  @Prop({ type: String })
  private value!: String | null

  @Ref()
  private input!: HTMLInputElement

  private title = this.text ?? this.value

  private copy() {
    copyToClipboard(this.input)
  }
}
